<template lang="pug">
  b-row.justify-content-end.ml-0
    b-col(cols="auto")
      b-button.mt-1(variant="soft-primary", v-b-modal="(view||'section') + '_modal'")
        v-icon.mr-2(name="graduation-cap")
        span Tutorial de {{ view || 'sección' }}
      b-modal(:id="(view||'section') + '_modal'", ok-only, ok-title="Cerrar tutorial", ok-variant="secondary", size="lg")
        slot
</template>

<script>
export default {
  props: {
    view: {
      type: String,
      default: ''
    }
  }
}
</script>

<style></style>
